module.exports = __webpack_public_path__ + "static/img/3.038c66b2.jpg";